














































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { BModal } from 'bootstrap-vue';
import FormatHelper from '~/helpers/format-helper';
import GoogleReviews from '~/components/core/GoogleReviews.vue';
import GooglePhotos from '~/components/core/GooglePhotos.vue';
import MapMarker from '~/components/maps/MapMarker.vue';
import Gmap from '~/components/maps/Gmap.vue';

@Component({
	components: {
		GoogleReviews: GoogleReviews,
		GooglePhotos: GooglePhotos,
		MapMarker: MapMarker,
		Gmap: Gmap,
	},
})
export default class DetailsTravelPack extends Vue {
	@Prop({ default: {}, required: true }) private model;
	@Prop({ default: 0, required: false }) private tab;
	@Prop({ default: 0, required: false }) private cardRating;
	@Prop({ default: 0, required: false }) private cardRates;

	$refs!: {
		modal: BModal;
	};

	private value: any;
	private tabData: any;
	private selected: any = {};
	private marker: any = {};

	private config = {
		clickableIcons: true,
		streetViewControl: false,
		panControlOptions: false,
		gestureHandling: 'cooperative',
		mapTypeControl: false,
		zoom: 15,
		center: { lat: 0, lng: 0 },
	};

	constructor() {
		super();
		this.value = {};
		this.tabData = 0;
		this.selected = {};
	}

	@Watch('model')
	modelChange(value) {
		this.value = value;
		this.selected = value;
	}

	@Watch('tab')
	tabChange(value) {
		this.tabData = value;
	}

	mounted() {
		if (this.model) {
			this.value = this.model;
		}
		if (this.tab) {
			this.tabData = this.tab;
		}
		if (this.model) {
			this.selected = this.model;

		}
	}

	showModal(value) {
		this.tabData = value;
		this.$refs.modal.show();
	}

	closeModal() {
		this.$refs.modal.hide();
	}

	get getImgUrl() {
		return process.env.API_IMG_URL + this.value['img_url'];
	}

	formatDate(date) {
		if (date) {
			return FormatHelper.formatDate(date);
		}
	}

	formatPrice(price) {
		if (price) {
			return FormatHelper.formatPrice(price);
		}
	}

	get getDays() {
		if (this.value.days > 0) {
			return this.value.days + ' / ' + (this.value.days - 1);
		}
		return '';
	}

	get configMap() {
		if (this.selected && this.selected.accommodation && this.selected.accommodation.lat && this.selected.accommodation.lon) {
			this.marker = {
				id: this.selected.accommodation.id.toString(),
				title: this.selected.accommodation.name,
				position: {
					lat: parseFloat(this.selected.accommodation.lat),
					lng: parseFloat(this.selected.accommodation.lon),
				},
			};
			this.config.center.lat = parseFloat(this.selected.accommodation.lat);
			this.config.center.lng = parseFloat(this.selected.accommodation.lon);
		}
		return this.config;
	}

	get selectedPhotos(): string[] {
		let photos: string[] = [];

		if (this.selected?.accommodation) {
			const accommodation = this.value?.accommodation;

			for (let i = 0; i <= 5; i++) {
				const key = i === 0 ? 'img_url' : `img_url_${i}`;
				const imgUrl = accommodation?.[key];

				if (typeof imgUrl === 'string' && imgUrl.trim() !== '') {
					photos.push(imgUrl);
				}
			}
		}

		return photos;
	}


}
